import { render, staticRenderFns } from "./ClinicInfo.vue?vue&type=template&id=04facf5d&scoped=true"
import script from "./ClinicInfo.vue?vue&type=script&lang=js"
export * from "./ClinicInfo.vue?vue&type=script&lang=js"
import style0 from "./ClinicInfo.vue?vue&type=style&index=0&id=04facf5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04facf5d",
  null
  
)

export default component.exports